module.exports = __webpack_public_path__ + "img/attendance.b3344806.png";